// src/pages/admin/BlockSlotsAdmin.js
import React, { useEffect, useState, useMemo } from "react";
import { Trash2 } from "lucide-react";
import  "./adminstyle.css";
const BlockSlotsAdmin = () => {
  const [venues, setVenues] = useState([]);
  const [selectedVenue, setSelectedVenue] = useState("");
  const [courts, setCourts] = useState([]);
  const [selectedCourt, setSelectedCourt] = useState(null);
  const [selectedDate, setSelectedDate] = useState("");
  const [availableSlots, setAvailableSlots] = useState([]);
  const [blockedSlots, setBlockedSlots] = useState([]);
  const [selectedSlotsToBlock, setSelectedSlotsToBlock] = useState([]);
  const [monthlyBlockedSlots, setMonthlyBlockedSlots] = useState([]);
  const [dailyBlockedSlots, setDailyBlockedSlots] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedMonth, setSelectedMonth] = useState("");
  const [activeSection, setActiveSection] = useState("block"); // "block" | "manage"
const [selectedMonthlyForUnblock, setSelectedMonthlyForUnblock] = useState([]);

  const token = localStorage.getItem("token");

  /* ----------------------- LOADERS ----------------------- */
  useEffect(() => {
    fetch("https://api.getfitindia.in/api/venues")
      .then((res) => res.json())
      .then(setVenues)
      .catch(console.error);
  }, []);

  useEffect(() => {
    const venue = venues.find((v) => v._id === selectedVenue);
    setCourts(venue?.courts || []);
    if (selectedCourt && !venue?.courts.some((c) => c._id === selectedCourt._id)) {
      setSelectedCourt(null);
    }
  }, [selectedVenue, venues, selectedCourt]);

  useEffect(() => {
    if (!selectedCourt || !selectedDate) return;

    const loadSlots = async () => {
      try {
        const slotRes = await fetch(
          `https://api.getfitindia.in/api/slots/${selectedVenue}/${selectedCourt._id}/slots`
        );
        setAvailableSlots(await slotRes.json());

        const blockedRes = await fetch(
          `https://api.getfitindia.in/api/block/${selectedVenue}/${selectedCourt._id}?date=${selectedDate}`
        );
        setBlockedSlots(await blockedRes.json());
      } catch (err) {
        console.log("Slot Load Error", err);
      }
    };

    loadSlots();
  }, [selectedCourt, selectedDate, selectedVenue]);

  const fetchGlobalBlockedSlots = async () => {
    try {
      const res = await fetch("https://api.getfitindia.in/api/block/blocked");
      const { dailyBlocked = [], monthlyBlocked = [] } = await res.json();
      setMonthlyBlockedSlots(monthlyBlocked);
      setDailyBlockedSlots(dailyBlocked);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    fetchGlobalBlockedSlots();
  }, []);

  /* ----------------------- HELPERS ----------------------- */

  const isBlocked = (slot) =>
    blockedSlots.some(
      (b) => b.startTime === slot.startTime && b.endTime === slot.endTime
    );

  const isSelected = (slot) =>
    selectedSlotsToBlock.some(
      (s) => s.startTime === slot.startTime && s.endTime === slot.endTime
    );

  const handleSlotToggle = (slot) => {
    setSelectedSlotsToBlock((prev) =>
      isSelected(slot)
        ? prev.filter(
            (s) => s.startTime !== slot.startTime || s.endTime !== slot.endTime
          )
        : [...prev, slot]
    );
  };
const formatTime12 = (t) => {
  if (!t) return "";
  const [hStr, mStr] = t.split(":");
  const h = parseInt(hStr, 10);
  const m = parseInt(mStr || "0", 10);

  const suffix = h >= 12 ? "PM" : "AM";
  const hour12 = h % 12 || 12;
  const minutes = m.toString().padStart(2, "0");

  return `${hour12}:${minutes} ${suffix}`;
};

  const formatDate = (d) =>
    d ? new Date(d).toLocaleDateString() : "";
const groupedDailyBlocked = useMemo(() => {
  const groups = {};

  dailyBlockedSlots.forEach((slot) => {
    // group by venue + court + date
    const key = `${slot.venueId}-${slot.courtId}-${slot.date}`;
    if (!groups[key]) {
      groups[key] = {
        venueId: slot.venueId,
        courtId: slot.courtId,
        venueName: slot.venueName,
        courtName: slot.courtName,
        date: slot.date,
        slots: [],
      };
    }
    groups[key].slots.push({
      _id: slot._id,
      startTime: slot.startTime,
      endTime: slot.endTime,
    });
  });

  // sort times inside each group
  const parseMinutes = (t) => {
    if (!t) return 0;
    const [h, m] = t.split(":").map(Number);
    return h * 60 + (m || 0);
  };

  Object.values(groups).forEach((g) => {
    g.slots.sort(
      (a, b) => parseMinutes(a.startTime) - parseMinutes(b.startTime)
    );
  });

  return Object.values(groups);
}, [dailyBlockedSlots]);
// check if an item belongs to same monthly period + same slot
const isSameMonthlyItem = (item, group, slot) => {
  return (
    item.venueId === group.venueId &&
    item.courtId === group.courtId &&
    new Date(item.startDate).getTime() === new Date(group.startDate).getTime() &&
    new Date(item.endDate).getTime() === new Date(group.endDate).getTime() &&
    item.startTime === slot.startTime &&
    item.endTime === slot.endTime
  );
};

// toggle selection of a monthly slot for unblock
const toggleMonthlyUnblockSlot = (group, slot) => {
  setSelectedMonthlyForUnblock((prev) => {
    const exists = prev.some((item) => isSameMonthlyItem(item, group, slot));

    if (exists) {
      // remove from selection
      return prev.filter((item) => !isSameMonthlyItem(item, group, slot));
    }

    // add to selection
    return [
      ...prev,
      {
        venueId: group.venueId,
        courtId: group.courtId,
        startDate: group.startDate,
        endDate: group.endDate,
        startTime: slot.startTime,
        endTime: slot.endTime,
      },
    ];
  });
};

// unblock selected slots for ONE group (period)
// unblock ENTIRE MONTH for this group, using existing /unblock-month API
const handleUnblockMonthlyGroup = async (group) => {
  const d = new Date(group.startDate);
  const year = d.getFullYear();
  const month = d.getMonth() + 1; // JS month is 0-based

  if (
    !window.confirm(
      `Unblock ALL blocked slots for:\n` +
        `${group.venueName} - ${group.courtName}\n` +
        `${formatDate(group.startDate)} → ${formatDate(group.endDate)} ?`
    )
  ) {
    return;
  }

  try {
    const res = await fetch("https://api.getfitindia.in/api/block/unblock-month", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        venueId: group.venueId,
        courtId: group.courtId,
        year,
        month,
      }),
    });

    if (!res.ok) throw new Error("Failed");

    await fetchGlobalBlockedSlots();
    alert("Month unblocked for this court.");
  } catch (err) {
    console.error(err);
    alert("Failed to unblock month");
  }
};


  // 🔹 Group monthly blocked slots by venue + court + date range
  const groupedMonthlyBlocked = useMemo(() => {
  const groups = {};

  monthlyBlockedSlots.forEach((slot) => {
    const key = `${slot.venueId}-${slot.courtId}-${slot.startDate}-${slot.endDate}`;

    if (!groups[key]) {
      groups[key] = {
        venueId: slot.venueId,
        courtId: slot.courtId,
        venueName: slot.venueName,
        courtName: slot.courtName,
        startDate: slot.startDate,
        endDate: slot.endDate,
        slots: [],
        _timeSet: new Set(), // <– used only for dedupe
      };
    }

    const timeKey = `${slot.startTime}-${slot.endTime}`;

    // ✅ only push if we haven't already added this time range
    if (!groups[key]._timeSet.has(timeKey)) {
      groups[key]._timeSet.add(timeKey);
      groups[key].slots.push({
        startTime: slot.startTime,
        endTime: slot.endTime,
      });
    }
  });

  // sort slots inside each group by startTime
  const parseMinutes = (t) => {
    if (!t) return 0;
    const [h, m] = t.split(":").map(Number);
    return h * 60 + (m || 0);
  };

  return Object.values(groups).map((g) => {
    g.slots.sort(
      (a, b) => parseMinutes(a.startTime) - parseMinutes(b.startTime)
    );
    // drop the private _timeSet before returning
    const { _timeSet, ...rest } = g;
    return rest;
  });
}, [monthlyBlockedSlots]);


  /* ----------------------- ACTIONS ----------------------- */

  const handleBlock = async () => {
    if (!selectedCourt || !selectedDate || selectedSlotsToBlock.length === 0)
      return alert("Select court, date, and slots.");

    try {
      const res = await fetch("https://api.getfitindia.in/api/block", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          venueId: selectedVenue,
          courtId: selectedCourt._id,
          date: selectedDate,
          slots: selectedSlotsToBlock,
        }),
      });

      if (res.ok) {
        alert("Slots Blocked!");
        fetchGlobalBlockedSlots();
        setSelectedSlotsToBlock([]);
      }
    } catch (err) {
      alert("Failed");
    }
  };

  const handleMonthlyBlock = async () => {
    if (!selectedDate) return;

    if (!window.confirm("Block selected slots for the full month?")) return;

    const year = new Date(selectedDate).getFullYear();
    const month = new Date(selectedDate).getMonth() + 1;

    try {
      const res = await fetch("https://api.getfitindia.in/api/block/bulk", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          venueId: selectedVenue,
          courtId: selectedCourt._id,
          year,
          month,
          slots: selectedSlotsToBlock,
        }),
      });

      if (res.ok) {
        alert("Blocked for month!");
        fetchGlobalBlockedSlots();
      }
    } catch (err) {
      console.error(err);
    }
  };

  const handleUnblock = async (id) => {
    if (!window.confirm("Unblock this slot?")) return;

    try {
      await fetch(`https://api.getfitindia.in/api/block/${id}`, {
        method: "DELETE",
        headers: { Authorization: `Bearer ${token}` },
      });

      fetchGlobalBlockedSlots();
    } catch (err) {
      console.error(err);
    }
  };

  const handleUnblockFullMonth = async () => {
    if (!selectedMonth || !selectedCourt || !selectedVenue) return;

    if (!window.confirm("Unblock ALL slots for this month?")) return;

    const [year, month] = selectedMonth.split("-").map(Number);

    try {
      await fetch("https://api.getfitindia.in/api/block/unblock-month", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          venueId: selectedVenue,
          courtId: selectedCourt._id,
          year,
          month,
        }),
      });

      fetchGlobalBlockedSlots();
    } catch (err) {
      console.error(err);
    }
  };

  /* ----------------------- UI ----------------------- */

  return (
    <div className="min-h-screen bg-[#F6F8FC]">
      {/* HEADER */}
      <div className="bg-[#0f2250] text-white sticky top-0 z-20 shadow-md">
        <div className="max-w-6xl  px-5 py-4">
          <h1 className="text-lg font-semibold ms-12 sm:ms-0 mt-1">
            Block Slots 
          </h1>
        </div>
      </div>

      {/* MAIN CONTENT */}
      <div className="max-w-6xl mx-0 lg:mx-8 px-4 py-6">
        {/* TOGGLE BUTTONS */}
        <div className="flex gap-3 mb-5 border-b pb-3">
          <button
            type="button"
            onClick={() => setActiveSection("block")}
            className={`px-4 py-2 rounded-full text-sm font-semibold transition
              ${
                activeSection === "block"
                  ? "bg-[#0f2250] text-white shadow"
                  : "bg-white text-[#0f2250] border border-gray-300 hover:bg-gray-100"
              }`}
          >
             Block Slots
          </button>
          <button
            type="button"
            onClick={() => setActiveSection("manage")}
            className={`px-4 py-2 rounded-full text-sm font-semibold transition
              ${
                activeSection === "manage"
                  ? "bg-[#0f2250] text-white shadow"
                  : "bg-white text-[#0f2250] border border-gray-300 hover:bg-gray-100"
              }`}
          >
             Unblock Slots
          </button>
        </div>

        {/* SECTION: BLOCK SLOTS */}
        {activeSection === "block" && (
          <div className=" w-full">
            {/* Title */}
            <h2 className="text-md font-semibold text-[#0f2250] mb-5">
               Block Slots
            </h2>

        {/* Filters Row: Venue + Court + Date */}
<div className="grid grid-cols-1 lg:grid-cols-3 gap-0 sm:gap-4 mb-4">
  {/* Venue */}
  <div>
    <label className="text-gray-700 text-sm font-medium mb-1">Select Venue</label>
    <select
      className="h-10 w-full rounded-lg border px-3 text-sm mb-4"
      value={selectedVenue}
      onChange={(e) => setSelectedVenue(e.target.value)}
    >
      <option value="">Choose Venue</option>
      {venues.map((v) => (
        <option value={v._id} key={v._id}>
          {v.name}
        </option>
      ))}
    </select>
  </div>

  {/* Court */}
  <div>
    <label className="text-gray-700 text-sm font-medium mb-1">Select Court</label>
    <select
      className="h-10 w-full rounded-lg border px-3 text-sm mb-4"
      value={selectedCourt?._id || ""}
      onChange={(e) =>
        setSelectedCourt(courts.find((c) => c._id === e.target.value))
      }
      disabled={!courts.length}
    >
      <option value="">Choose Court</option>
      {courts.map((c) => (
        <option value={c._id} key={c._id}>
          {c.courtName} ({c.sports.join(", ")})
        </option>
      ))}
    </select>
  </div>

  {/* Date */}
  <div>
    <label className="text-gray-700 text-sm font-medium mb-1">Select Date</label>
    <input
      type="date"
      className="h-10 w-full rounded-lg border px-3 text-sm mb-4"
      value={selectedDate}
      disabled={!selectedCourt}
      onChange={(e) => setSelectedDate(e.target.value)}
    />
  </div>
</div>


            {/* Select All */}
            {availableSlots.length > 0 && (
              <label className="text-sm flex items-center gap-2 mb-3 font-medium text-gray-600">
                <input
                  type="checkbox"
                  onChange={(e) => {
                    if (e.target.checked) {
                      const unblocked = availableSlots.filter(
                        (s) => !isBlocked(s)
                      );
                      setSelectedSlotsToBlock(unblocked);
                    } else {
                      setSelectedSlotsToBlock([]);
                    }
                  }}
                  checked={
                    selectedSlotsToBlock.length > 0 &&
                    selectedSlotsToBlock.length ===
                      availableSlots.filter((s) => !isBlocked(s)).length
                  }
                />
                Select All Slots
              </label>
            )}

            {/* SLOTS LIST */}
          {/* SLOTS LIST – show only when we have slots */}
{selectedCourt && selectedDate && availableSlots.length > 0 && (
  <div className="bg-white rounded-xl shadow-sm p-4 border">
    <div className="grid grid-cols-1 md:grid-cols-3 gap-3 max-h-64 overflow-y-auto pb-1">
      {availableSlots.map((slot, idx) => {
        const blocked = isBlocked(slot);
        const selected = isSelected(slot);

        return (
          <div
            key={idx}
            className={`
              rounded-lg p-3 border cursor-pointer text-sm transition-all duration-150 ease-in-out
              ${
                blocked
                  ? "bg-red-100 border-red-300 text-red-700"
                  : selected
                  ? "bg-yellow-100 border-orange-300 text-orange-500"
                  : "bg-gray-100 border-gray-300 hover:bg-gray-200"
              }
            `}
            onClick={() => !blocked && handleSlotToggle(slot)}
          >
            <div className="font-medium">
              {formatTime12(slot.startTime)} - {formatTime12(slot.endTime)}
            </div>

            {blocked && (
              <div className="mt-1 text-xs font-semibold text-red-700">
                Blocked
              </div>
            )}

            {selected && !blocked && (
              <div className="mt-1 text-xs font-semibold text-orange-500">
                To Block
              </div>
            )}
          </div>
        );
      })}
    </div>
  </div>
)}


            {/* ACTION BUTTONS */}
            {selectedSlotsToBlock.length > 0 && (
              <div className="flex flex-wrap gap-3 mt-5">
                <button
                  className="h-9 px-3 text-sm rounded-lg font-semibold bg-[#0f2250] text-white hover:opacity-90 flex items-center gap-2"
                  onClick={handleBlock}
                >
                  Block Selected
                </button>
                <button
                  className="h-9 px-3 text-sm rounded-lg font-semibold bg-[#0f2250] text-white hover:opacity-90 flex items-center gap-2"
                  onClick={handleMonthlyBlock}
                >
                  Block Full Month
                </button>
              </div>
            )}
          </div>
        )}

        {/* SECTION: MANAGE BLOCKED SLOTS */}
        {activeSection === "manage" && (
          <div className=" w-full">
            {/* Search */}
            <input
              type="text"
              placeholder="Search venue..."
              className="h-10 w-full rounded-lg border px-3 text-sm mb-4 input-style "
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value.toLowerCase())}
            />

            {/* MONTHLY BLOCKED – GROUPED VIEW LIKE YOUR SCREENSHOT */}
       <h3 className="text-md font-semibold text-[#0f2250] mb-5"> Monthly Blocked Slots</h3>
<div className="list-scroll">
  {groupedMonthlyBlocked
    .filter((g) =>
      g.venueName?.toLowerCase().includes(searchTerm)
    )
    .map((group) => (
      <div
        key={`${group.venueId}-${group.courtId}-${group.startDate}-${group.endDate}`}
        className="bg-purple-50 border border-purple-200 rounded-xl p-4 mb-3"
      >
        {/* Header: venue, court, date range */}
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between mb-3">
          <div>
            <p className="font-semibold text-[#0f2250]">
              {group.venueName}
            </p>
            <p className="text-sm text-gray-700">{group.courtName}</p>
          </div>
          <div className="text-xs sm:text-sm text-gray-600 mt-2 sm:mt-0">
            {formatDate(group.startDate)} &rarr; {formatDate(group.endDate)}
          </div>
        </div>

        {/* Slots grid (read-only list of times) */}
        <div className="bg-white rounded-xl border p-3">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-3 max-h-40 overflow-y-auto">
            {group.slots.map((slot, idx) => (
              <div
                key={idx} style={{fontSize:12}}
                className="bg-gray-100 border border-gray-300 rounded-lg px-3 py-2  flex items-center"
              >
                {formatTime12(slot.startTime)} - {formatTime12(slot.endTime)}
              </div>
            ))}
          </div>
        </div>

        {/* Unblock full month for this group */}
        <div className="mt-3 flex justify-end">
          <button
            onClick={() => handleUnblockMonthlyGroup(group)} style={{fontSize:12}}
            className="h-9 px-4  rounded-lg font-semibold bg-red-600 text-white hover:bg-red-700"
          >
            Unblock Full Month for this Court
          </button>
        </div>
      </div>
    ))}
</div>



            {/* DAILY BLOCKED */}
          {/* DAILY BLOCKED */}
<h3 className="text-md font-semibold text-[#0f2250] mb-5"> Daily Blocked Slots</h3>
<div className="list-scroll">
  {groupedDailyBlocked
    .filter((g) =>
      g.venueName?.toLowerCase().includes(searchTerm)
    )
    .map((group) => (
      <div
        key={`${group.venueId}-${group.courtId}-${group.date}`}
        className="bg-red-50 border border-red-200 rounded-xl p-4 mb-3"
      >
        {/* Header: venue, court, date */}
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between mb-3">
          <div>
            <p className="font-semibold text-[#0f2250]">
              {group.venueName}
            </p>
            <p className="text-sm text-gray-700">
              {group.courtName}
            </p>
          </div>
          <div className="text-xs sm:text-sm text-gray-600 mt-2 sm:mt-0">
            {new Date(group.date).toLocaleDateString()}
          </div>
        </div>

        {/* Slots grid (same style as monthly screenshot) */}
        <div className="bg-white rounded-xl border p-3">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-3 max-h-40 overflow-y-auto">
            {group.slots.map((slot) => (
              <div
                key={slot._id} style={{fontSize:12}}
                className="bg-gray-100 border border-gray-300 rounded-lg px-3 py-2 flex items-center justify-between"
              >
                <span>
                      {formatTime12(slot.startTime)} - {formatTime12(slot.endTime)}
                </span>
                <button
                  onClick={() => handleUnblock(slot._id)}
                  className="text-red-600 hover:text-red-900 ml-2"
                >
                  <Trash2 size={16} />
                </button>
              </div>
            ))}
          </div>
        </div>
      </div>
    ))}
</div>


            {/* UNBLOCK MONTH */}
            {/* <div className="bg-red-50 border border-red-300 rounded-xl p-4 mt-6 shadow-sm">
              <h3 className="section-title-red mb-3">🔓 Unblock Full Month</h3>

              <div className="flex flex-col sm:flex-row gap-3">
                <select
                  className="input-style"
                  value={selectedVenue}
                  onChange={(e) => setSelectedVenue(e.target.value)}
                >
                  <option value="">Select Venue</option>
                  {venues.map((v) => (
                    <option key={v._id} value={v._id}>
                      {v.name}
                    </option>
                  ))}
                </select>

                {courts.length > 0 && (
                  <select
                    className="input-style"
                    value={selectedCourt?._id || ""}
                    onChange={(e) =>
                      setSelectedCourt(
                        courts.find((c) => c._id === e.target.value)
                      )
                    }
                  >
                    <option value="">Select Court</option>
                    {courts.map((c) => (
                      <option key={c._id} value={c._id}>
                        {c.courtName}
                      </option>
                    ))}
                  </select>
                )}

                <input
                  type="month"
                  className="input-style"
                  value={selectedMonth}
                  onChange={(e) => setSelectedMonth(e.target.value)}
                />

                <button
                  onClick={handleUnblockFullMonth}
                  className="btn-red"
                  disabled={!selectedVenue || !selectedCourt || !selectedMonth}
                >
                  Unblock
                </button>
              </div>
            </div> */}
          </div>
        )}
      </div>
    </div>
  );
};

export default BlockSlotsAdmin;
